
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsList/[id]",
      function () {
        return require("private-next-pages/newsList/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsList/[id]"])
      });
    }
  